module.exports = __webpack_public_path__ + "static/media/FlorianGraf_previous.55bdc472.svg";